class CartCount extends HTMLElement {
  constructor() {
    super();

    this.updateCount();

    document.addEventListener("addtocart", () => {
      this.updateCount();
    });

    document.addEventListener("cartchange", () => {
      this.updateCount();
    });
  }

  updateCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        this.textContent = cart.item_count;
        this.dataset.count = cart.item_count;
      });
  }
}

customElements.define("component-cart-count", CartCount);